export function TxtIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path d="M9,13L9,6L11,6L11,13L12,13L12,15L8,15L8,13L9,13Z" />
      <path d="M7,8L5,8L5,6C5,5.448 5.448,5 6,5L14,5C14.552,5 15,5.448 15,6L15,8L13,8L13,7L7,7L7,8Z" />
    </svg>
  );
}
